import axios from "axios";
import {
  AddIdentifier,
  AddIdentifierVerification,
} from "../../Models/Request/Identifier/AddIdentifier";

export function getIdentifiers() {
  return axios.get(`/User/Identifiers`);
}

export function getMobileIdentifiers() {
  return axios.get(`/User/Identifiers/mobile`);
}

export function addIdentifier(body: AddIdentifier) {
  return axios.post(`/User/Identifiers`, body);
}

export function addIdentifierVerification(body: AddIdentifierVerification) {
  return axios.post(`/User/Identifiers/Verify`, body);
}

export const deleteIdentifier = (id: string) => {
  console.log("delete identifier id: ",id)
  return axios.delete("/User/Identifiers", {
    data: JSON.stringify(id),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const verifyAndDeleteIdentifier = (request: {
  id: string;
  otpUniqueID: string;
  code: string;
}) => {
  return axios.post(
    "/User/Identifiers/Delete/Verify",
    request
  );
};
